module.exports = __webpack_public_path__ + "img/demo_nightclub-600x450.21b24f7e.jpg";